import * as types from '../../actionTypes';

const initialState = {
    printReportAppointments: [],
    error: {},
    loading: false,
}


export  const printReportAppointmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.PRINT_REPOPRT_APPOINTMENT_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.PRINT_REPOPRT_APPOINTMENT_SUCCESS:
            console.log("actionddddd",action.payload)
            return {
                ...state,
                printReportAppointments: action.payload,
                loading: false,
                error: {}
            }
        case types.PRINT_REPOPRT_APPOINTMENT_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
                printReportAppointments: []
            }
        
        default:
            return state;
    }
}